import { render } from "./order-status-graphic-icon.vue?vue&type=template&id=585f8cbd&scoped=true"
import script from "./order-status-graphic-icon.vue?vue&type=script&lang=js"
export * from "./order-status-graphic-icon.vue?vue&type=script&lang=js"

import "./order-status-graphic-icon.vue?vue&type=style&index=0&id=585f8cbd&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585f8cbd"]])

export default __exports__